import React from 'react';
import { Helmet } from 'react-helmet-async';
import html2pdf from 'html2pdf.js';
import { sendGAPageview } from '../utils/gaConsent';
import CookiesContentFromMarkdown from '../components/Cookies/CookiesContentFromMarkdown';
import $ from 'jquery';
import { PrinterIcon } from '@heroicons/react/24/solid';

export default function CookiesPolicy() {
  $('.popover').hide();
  sendGAPageview({
    hitType: 'pageview',
    page: '/Cookies-policy',
    title: 'Cookies policy',
  });

  const downloadSummary = () => {
    const element = document.getElementById('printer');
    if (!element) return;
    element.classList.add('pdf-mode');
    const opt = {
      margin: [20, 40, 40, 20] as [number, number, number, number],
      filename: 'cookies-policy.pdf',
      image: { type: 'jpeg' as const, quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' as const },
      pagebreak: {
        mode: ['avoid-all', 'css', 'legacy'],
      },
    };
    html2pdf()
      .set(opt)
      .from(element)
      .save()
      .then(() => {
        element.classList.remove('pdf-mode');
      });
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>DISGENET: Cookies Policy</title>
        <meta name="description" content="" />

        {/* Open Graph Tags for LinkedIn */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.disgenet.com/Cookies-policy" />
        <meta property="og:title" content="DISGENET: Cookies Policy" />
        <meta
          property="og:description"
          content="This policy describes the cookies used by MedBioinformatics Solutions S.L (hereinafter, 'MedBio', the 'Company', or 'we/us')"
        />
      </Helmet>
      <section>
        <link rel="canonical" href="/Cookies-policy" />
        <div className="container txt-contenido text-right">
          <button
            className="btn bg-light rounded-circle mr-12"
            onClick={downloadSummary}
            title="Download PDF"
          >
            <PrinterIcon className="w-4 h-4" />
          </button>
        </div>
        <div className="container txt-contenido" id="printer">
          <CookiesContentFromMarkdown />
        </div>
      </section>
    </React.Fragment>
  );
}
